<template>
    <AppContainer>
        <div class="grid lg:grid-cols-3 gap-4">
            <div class="lg:col-span-2">
                <slot name="left"></slot>
            </div>

            <div class="hidden lg:block">
                <slot name="right"></slot>
            </div>
        </div>
    </AppContainer>
</template>

<script>
import AppContainer from '@/Layouts/AppContainer';

export default {
    components: { AppContainer }
}
</script>

<style scoped>

</style>
